import {
  FaAddressCard,
  FaCircle,
  FaEnvelope,
  FaHome,
  FaInfoCircle,
  FaSignOutAlt,
  FaPaperPlane,
  FaFileAlt,
  FaPlusCircle,
  FaBook,
  FaSearch,
  FaClipboardCheck,
  FaKey,
  FaFileUpload,
  FaPenFancy,
  FaUpload,
} from "react-icons/fa";
import { setOffcanvasOpen } from "src/state/slices/asideslice";
import { userLogout } from "src/state/slices/authSlice";
import { CNavBarItemT } from "./navigationType";
import AuthorProfile from "src/pages/components/AuthorProfile";

import MyPaper from "src/pages/MyPaper";
import AddPublication from "src/pages/components/AddPublication";
import SearchJournal from "src/pages/components/SearchJournal";
import PublishRequests from "src/components/PublishRequests";
import ChangePasswordPage from "src/pages/components/ChangePassword";
import CreateResearchPage from "src/pages/CreateResearchPage";
import PublicationList from "src/components/PublicationList";

export const AuthorNavbar: CNavBarItemT[] = [
  {
    label: "Profile",
    href: "/",
    icon: <FaHome className="custom-icon" />,
    component: AuthorProfile,
  },

  {
    label: "⁠Search Journals",
    href: "/search-journal",
    icon: <FaSearch className="custom-icon" />,
    component: SearchJournal,
  },

  {
    label: "Research Papers",
    href: "/my-papers",
    icon: <FaFileAlt className="custom-icon" />,
    component: MyPaper,
  },

  {
    label: "Submit Research Paper",
    href: "/create-research",
    icon: <FaPenFancy className="custom-icon" />,
    component: CreateResearchPage,
  },

  {
    label: "Publish Requests",
    href: "/publish-requests",
    icon: <FaClipboardCheck className="custom-icon" />,
    component: PublishRequests,
  },

  {
    label: "Add Publications",
    href: "/add-publication",
    icon: <FaPlusCircle className="custom-icon" />,
    component: AddPublication,
  },
  {
    label: "My Publications",
    href: "/publication-list",
    icon: <FaBook className="custom-icon" />,
    component: PublicationList,
  },

  {
    label: "Change Password",
    href: "/change-password",
    icon: <FaKey className="custom-icon" />,
    component: ChangePasswordPage,
  },
  {
    label: "Logout",
    href: "/",
    icon: <FaSignOutAlt className="custom-icon" />,
    onClick(dispatch) {},
  },
];
